module.exports = __webpack_public_path__ + "static/media/collective-lives-icon.daf5ee4c.svg";